import { CommunicationType } from '../../services/apiGateway/apiGatewayTypes'

type RenditionType = 'mp4' | 'm3u8'

function getRenditionByType (sources: CommunicationType['sources'] = [], fileType: RenditionType = 'mp4'): string | undefined {

  const mimeType = fileType === 'm3u8' ? 'x-mpegURL' : 'mp4'
  const rendition = sources.find(({ type }) => type.includes(mimeType))
  return rendition?.src

}

function getVideoSources(sources: CommunicationType['sources']): string[] {

  return <string[]>[
    getRenditionByType(sources, 'mp4'), getRenditionByType( sources, 'm3u8')
  ].filter( x => x !== undefined)
}

export default getVideoSources
